/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { SnapshotDateFilters } from '../models/SnapshotDateFilters';

export class SnapshotFilterConditions {
  'pointInTime'?: SnapshotDateFilters;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "pointInTime",
      "baseName": "pointInTime",
      "type": "SnapshotDateFilters",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return SnapshotFilterConditions.attributeTypeMap;
  }

  public constructor() {
  }
}

